import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const abPauseSubscription: string = getFeature('ab-pause-subscription');
